import React, { FC, lazy } from "react";

import { Routes } from "@Libs/Router/Components/Routes/Routes";
import { Route } from "@Libs/Router/Components/Route/Route";

const SignInPage = lazy(() =>
  import("../SignInPage/SignInPage").then(({ SignInPage }) => ({
    default: SignInPage,
  }))
);

const SignUpPage = lazy(() =>
  import("../SignUpPage/SignUpPage").then(({ SignUpPage }) => ({
    default: SignUpPage,
  }))
);

export const AuthRouter: FC = () => {
  return (
    <Routes>
      <Route fragments="SIGN_IN" element={<SignInPage />} />
      <Route fragments="SIGN_UP" element={<SignUpPage />} />
    </Routes>
  );
};
